/* ==========================================================================
   IRON FIT — the packages, in one place

   Both the packages carousel (ifz-packages.js) and the bundle preview page
   (ifz-bundle.js) read from here, so a price or a piece of kit is never
   edited in two files.

   Each package:
     id       · used in the URL — bundle.html?b=famous
     img      · the full-resolution poster master; it shows the whole kit and
                is never cropped
     img2x    · the same poster at 1400px, handed to retina and 3x phones
     price    · what you pay, all in
     was      · what the same kit costs bought one by one (drives the save block)
     items    · the things in the box — each one a photo tile on the page
                line: the exact wording the cart has always used
     perks    · what the price covers on top of the kit
     machine  · which machine is in the box, so the package page can show the
                same 3D model and hand it to the fit check
     plateKg  · how much plate weight is included, so the customer can choose
                which plates make it up
     shopify  · the Shopify product handle. The theme's builder reads prices
                from real variants, but falls back to the copy here when an
                offer metaobject has not been created for a package yet
   ========================================================================== */
window.IFZ_BUNDLES = (function () {
  'use strict';

  var DELIVERY = 'Delivery to your home — all Lebanon';
  var INSTALL  = 'Professional installation, assembly, calibration and testing';

  var LIST = [
    {
      id: 'compact',
      shopify: 'one-machine-gym',   /* the Shopify product handle */
      machine: 'compact',   /* the machine it is built around, for the 3D view */
      name: 'The One-Machine Gym',
      badge: 'Entry / Small space',
      solid: false,
      img: 'assets/01-compact-single-stack-570-all-in.jpg',
      img2x: 'assets/pkg-compact-1400.jpg',
      price: 570,
      was: null,
      tagline: 'A whole gym in under a square metre.',
      items: [
        {
          line: 'Compact single-stack machine — 94 × 100 cm of floor',
          name: 'Compact Single-Stack Machine',
          spec: 'Built-in weight stack. Dips, pull-ups, lat pulldowns, low rows and cable work — 226 × 94 × 100 cm.',
          img: 'assets/spin-compact-1-760.jpg',
          fit: 'contain'
        }
      ],
      perks: [DELIVERY, INSTALL],
      lead: 'One machine, one price, and our team standing it up in your room. Nothing else to buy to start training.'
    },

    {
      id: 'famous',
      shopify: 'famous-gym',   /* the Shopify product handle */
      plateKg: 20,   /* the plates in the box, in kg */
      machine: 'crossover',   /* the machine it is built around, for the 3D view */
      name: 'The Famous Gym',
      badge: 'Best value',
      solid: true,
      best: true,
      /* the poster with "20 KG" and "SAVE $231" painted in — the original
         still says 40 KG and is used by the 40 kg tier */
      img: 'assets/07-famous-gym-899-20kg.jpg',
      img2x: 'assets/pkg-famous-20kg-1400.jpg',
      price: 899,
      was: 1130,          /* 760 + 180 + 120 + 20 kg at $3 + $10 plate delivery */
      tagline: 'The one everybody orders. A complete gym, in one delivery.',
      items: [
        {
          line: 'Dual Cable Crossover machine — 2 × 75 kg stacks',
          name: 'Dual Cable Crossover',
          spec: 'Two independent 75 kg stacks, adjustable pulleys and a multi-grip pull-up station.',
          img: 'assets/spin-cable-1-760.jpg'
        },
        {
          line: 'Commercial adjustable bench',
          name: 'Commercial Adjustable Bench',
          spec: 'Flat to full upright, commercial padding, leg anchor for decline work.',
          img: 'assets/spin-bench-1-760.jpg'
        },
        {
          line: 'One 7 ft Olympic bar with collars',
          name: '7 FT Olympic Bar + Collars',
          spec: 'Full-length Olympic bar, knurled grip, collars in the box.',
          img: 'assets/spin-bar-1-760.jpg'
        },
        {
          line: '20 kg of rubber Olympic plates',
          name: '20 KG Rubber Olympic Plates',
          spec: 'Rubber-coated Olympic plates — quiet on the floor, easy on the bar.',
          img: 'assets/spin-plates-1-760.jpg'
        }
      ],
      perks: [DELIVERY, INSTALL],
      lead: 'Machine, bench, bar and plates arrive together, on the same day, installed by the same team. You train the evening it lands. Want more weight from day one? The 40 kg version is $959.'
    },

    {
      id: 'famous-40',
      shopify: 'famous-gym-40kg',   /* the Shopify product handle */
      plateKg: 40,   /* the plates in the box, in kg */
      machine: 'crossover',   /* the machine it is built around, for the 3D view */
      name: 'The Famous Gym — 40 KG',
      badge: 'More plates',
      solid: true,
      img: 'assets/07-famous-gym-949-40kg.jpg',
      price: 949,
      was: 1190,          /* the same kit, with 40 kg of plates bought loose */
      tagline: 'The same complete gym, with double the plates.',
      items: [
        {
          line: 'Dual Cable Crossover machine — 2 × 75 kg stacks',
          name: 'Dual Cable Crossover',
          spec: 'Two independent 75 kg stacks, adjustable pulleys and a multi-grip pull-up station.',
          img: 'assets/spin-cable-1-760.jpg'
        },
        {
          line: 'Commercial adjustable bench',
          name: 'Commercial Adjustable Bench',
          spec: 'Flat to full upright, commercial padding, leg anchor for decline work.',
          img: 'assets/spin-bench-1-760.jpg'
        },
        {
          line: 'One 7 ft Olympic bar with collars',
          name: '7 FT Olympic Bar + Collars',
          spec: 'Full-length Olympic bar, knurled grip, collars in the box.',
          img: 'assets/spin-bar-1-760.jpg'
        },
        {
          line: '40 kg of rubber Olympic plates',
          name: '40 KG Rubber Olympic Plates',
          spec: 'Double the plates of the $899 package — rubber-coated, quiet on the floor.',
          img: 'assets/spin-plates-1-760.jpg'
        }
      ],
      perks: [DELIVERY, INSTALL],
      lead: 'Everything in The Famous Gym with 40 kg of plates instead of 20 — $50 for the extra 20 kg, less than the $60 they cost loose, and they arrive on the same truck.'
    },

    {
      id: 'famous-60',
      shopify: 'famous-gym-60kg',   /* the Shopify product handle */
      plateKg: 60,   /* the plates in the box, in kg */
      machine: 'crossover',   /* the machine it is built around, for the 3D view */
      name: 'The Famous Gym — 60 KG',
      badge: 'Serious loading',
      solid: true,
      img: 'assets/07-famous-gym-999-60kg.jpg',
      price: 999,
      was: 1250,          /* the same kit, with 60 kg of plates bought loose */
      tagline: 'The same complete gym, with triple the plates.',
      items: [
        {
          line: 'Dual Cable Crossover machine — 2 × 75 kg stacks',
          name: 'Dual Cable Crossover',
          spec: 'Two independent 75 kg stacks, adjustable pulleys and a multi-grip pull-up station.',
          img: 'assets/spin-cable-1-760.jpg'
        },
        {
          line: 'Commercial adjustable bench',
          name: 'Commercial Adjustable Bench',
          spec: 'Flat to full upright, commercial padding, leg anchor for decline work.',
          img: 'assets/spin-bench-1-760.jpg'
        },
        {
          line: 'One 7 ft Olympic bar with collars',
          name: '7 FT Olympic Bar + Collars',
          spec: 'Full-length Olympic bar, knurled grip, collars in the box.',
          img: 'assets/spin-bar-1-760.jpg'
        },
        {
          line: '60 kg of rubber Olympic plates',
          name: '60 KG Rubber Olympic Plates',
          spec: 'Three times the plates of the $899 package — rubber-coated, quiet on the floor.',
          img: 'assets/spin-plates-1-760.jpg'
        }
      ],
      perks: [DELIVERY, INSTALL],
      lead: 'Everything in The Famous Gym with 60 kg of plates instead of 40 — $50 for the extra 20 kg, less than the $60 they cost loose, and they arrive on the same truck.'
    },

    {
      id: 'famous-80',
      shopify: 'famous-gym-80kg',   /* the Shopify product handle */
      plateKg: 80,   /* the plates in the box, in kg */
      machine: 'crossover',   /* the machine it is built around, for the 3D view */
      name: 'The Famous Gym — 80 KG',
      badge: 'Most plates',
      solid: true,
      img: 'assets/07-famous-gym-1049-80kg.jpg',
      price: 1049,
      was: 1310,          /* the same kit, with 80 kg of plates bought loose */
      tagline: 'The same complete gym, with four times the plates.',
      items: [
        {
          line: 'Dual Cable Crossover machine — 2 × 75 kg stacks',
          name: 'Dual Cable Crossover',
          spec: 'Two independent 75 kg stacks, adjustable pulleys and a multi-grip pull-up station.',
          img: 'assets/spin-cable-1-760.jpg'
        },
        {
          line: 'Commercial adjustable bench',
          name: 'Commercial Adjustable Bench',
          spec: 'Flat to full upright, commercial padding, leg anchor for decline work.',
          img: 'assets/spin-bench-1-760.jpg'
        },
        {
          line: 'One 7 ft Olympic bar with collars',
          name: '7 FT Olympic Bar + Collars',
          spec: 'Full-length Olympic bar, knurled grip, collars in the box.',
          img: 'assets/spin-bar-1-760.jpg'
        },
        {
          line: '80 kg of rubber Olympic plates',
          name: '80 KG Rubber Olympic Plates',
          spec: 'Four times the plates of the $899 package — rubber-coated, quiet on the floor.',
          img: 'assets/spin-plates-1-760.jpg'
        }
      ],
      perks: [DELIVERY, INSTALL],
      lead: 'Everything in The Famous Gym with 80 kg of plates instead of 60 — $50 for the extra 20 kg, less than the $60 they cost loose, and they arrive on the same truck.'
    },

    {
      id: 'smith-starter',
      shopify: 'smith-starter',   /* the Shopify product handle */
      plateKg: 40,   /* the plates in the box, in kg */
      machine: 'smith',   /* the machine it is built around, for the 3D view */
      name: 'The Smith Starter',
      badge: 'Entry Smith package',
      solid: false,
      img: 'assets/08-smith-starter-1199.jpg',
      img2x: 'assets/pkg-smith-starter-1400.jpg',
      price: 1199,
      was: 1369,
      tagline: 'Every big lift, guided — from the first session.',
      items: [
        {
          line: 'Multifunctional Smith machine, with its integrated Smith bar',
          name: 'Multifunctional Smith Machine',
          spec: 'Guided Smith bar, dual cable stations, J-hooks and plate horns in one frame.',
          img: 'assets/spin-smith-1-760.jpg'
        },
        {
          line: 'Commercial adjustable bench',
          name: 'Commercial Adjustable Bench',
          spec: 'Flat to full upright, commercial padding, leg anchor for decline work.',
          img: 'assets/spin-bench-1-760.jpg'
        },
        {
          line: '40 kg of rubber Olympic plates',
          name: '40 KG Rubber Olympic Plates',
          spec: 'Rubber-coated Olympic plates — quiet on the floor, easy on the bar.',
          img: 'assets/spin-plates-1-760.jpg'
        }
      ],
      perks: [DELIVERY, INSTALL],
      lead: 'The Smith frame does the balancing for you, so you can push heavy at home on your own, safely.'
    },

    {
      id: 'smith-complete',
      shopify: 'smith-complete',   /* the Shopify product handle */
      plateKg: 60,   /* the plates in the box, in kg */
      machine: 'smith',   /* the machine it is built around, for the 3D view */
      name: 'The Smith Complete',
      badge: 'Full Smith setup',
      solid: false,
      img: 'assets/09-smith-complete-1299.jpg',
      img2x: 'assets/pkg-smith-complete-1400.jpg',
      price: 1299,
      was: 1549,
      tagline: 'The Smith frame, plus a free bar to go with it.',
      items: [
        {
          line: 'Multifunctional Smith machine, with its integrated Smith bar',
          name: 'Multifunctional Smith Machine',
          spec: 'Guided Smith bar, dual cable stations, J-hooks and plate horns in one frame.',
          img: 'assets/spin-smith-1-760.jpg'
        },
        {
          line: 'Commercial adjustable bench',
          name: 'Commercial Adjustable Bench',
          spec: 'Flat to full upright, commercial padding, leg anchor for decline work.',
          img: 'assets/spin-bench-1-760.jpg'
        },
        {
          line: 'One 7 ft Olympic bar with collars',
          name: '7 FT Olympic Bar + Collars',
          spec: 'Full-length Olympic bar, knurled grip, collars in the box.',
          img: 'assets/spin-bar-1-760.jpg'
        },
        {
          line: '60 kg of rubber Olympic plates',
          name: '60 KG Rubber Olympic Plates',
          spec: 'Rubber-coated Olympic plates — quiet on the floor, easy on the bar.',
          img: 'assets/spin-plates-1-760.jpg'
        }
      ],
      perks: [DELIVERY, INSTALL],
      lead: 'Guided work on the Smith bar and free work on the Olympic bar, from the same frame, with plates for both.'
    },

    {
      id: 'smith-heavy',
      shopify: 'smith-heavy',   /* the Shopify product handle */
      plateKg: 80,   /* the plates in the box, in kg */
      machine: 'smith',   /* the machine it is built around, for the 3D view */
      name: 'The Smith Heavy',
      badge: 'Max weight',
      solid: false,
      img: 'assets/10-smith-heavy-1349.jpg',
      img2x: 'assets/pkg-smith-heavy-1400.jpg',
      price: 1349,
      was: 1609,
      tagline: 'For the ones who already lift heavy.',
      items: [
        {
          line: 'Multifunctional Smith machine, with its integrated Smith bar',
          name: 'Multifunctional Smith Machine',
          spec: 'Guided Smith bar, dual cable stations, J-hooks and plate horns in one frame.',
          img: 'assets/spin-smith-1-760.jpg'
        },
        {
          line: 'Commercial adjustable bench',
          name: 'Commercial Adjustable Bench',
          spec: 'Flat to full upright, commercial padding, leg anchor for decline work.',
          img: 'assets/spin-bench-1-760.jpg'
        },
        {
          line: 'One 7 ft Olympic bar with collars',
          name: '7 FT Olympic Bar + Collars',
          spec: 'Full-length Olympic bar, knurled grip, collars in the box.',
          img: 'assets/spin-bar-1-760.jpg'
        },
        {
          line: '80 kg of rubber Olympic plates',
          name: '80 KG Rubber Olympic Plates',
          spec: 'Rubber-coated Olympic plates — quiet on the floor, easy on the bar.',
          img: 'assets/spin-plates-1-760.jpg'
        }
      ],
      perks: [DELIVERY, INSTALL],
      lead: 'The same Smith frame with the heaviest plate load we package — 80 kg, delivered and installed.'
    }
  ];

  /* The cart has always stored the plain wording. Derive it rather than keep
     a second copy that can drift from the tiles. */
  LIST.forEach(function (b) {
    b.includes = b.items.map(function (i) { return i.line; });
    b.href = 'bundle.html?b=' + b.id;
  });

  function byId(id) {
    for (var i = 0; i < LIST.length; i++) if (LIST[i].id === id) return LIST[i];
    return null;
  }

  LIST.byId = byId;
  return LIST;
})();
